module.exports = __webpack_public_path__ + "static/media/pokedex.54d2e5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pokedex.png
// module id = 34
// module chunks = 0